export default __webpack_public_path__ + "static/media/right_arrow.248016b9.svg";